<template>
  <div
    id="page-wrapper"
    class="wrap-container wrap-container--has-margin-bottom"
    role="main"
  >
    <on-page-breadcrumbs :data="breadcrumbs" />
    <div class="policies-info-page">
      <div class="row-center-noGutter fade-in">
        <preamble-block
          class="col-12_md-8_lg-6"
          :prefix="prefix"
          :title="title"
          :preamble="preamble"
          :align="!image ? 'left': 'center'"
        />
      </div>
      <BylineShareComponent
        :author="author"
        :authordate="authorDate"
        :title="seoTitle || title"
        :description="seoDescription"
        :size="!image ? 'narrow' : 'wide'"
        :align="!image ? 'left': 'center'"
      />
      <div class="row-center-noGutter fade-in">
        <div
          v-if="image || videoUrl"
          class="col-12"
        >
          <image-video-component
            :alt="alt"
            :video-url="videoUrl"
            :image="image"
            :use-picture="false"
            :auto-aspect-ratio="false"
          />
        </div>
        <div
          v-if="content.length || contentBlocks.length || isEditable"
          class="col-12_md-10_lg-8"
        >
          <div
            v-if="hasAccordions"
            class="toggle-accordions--wrapper"
          >
            <ica-toggle-switch
              v-model="expandAccordions"
              text="Visa alla texter på sidan"
              aria-label="toggle switch"
            />

            <hr>
          </div>
          <div
            v-if="content.length || isEditable"
          >
            <wysiwyg
              v-edit="'Content'"
              class="wysiwyg--contentarea"
              :content="content"
            />
          </div>
          <div
            v-if="contentBlocks.length || (isEditable && contentBlocks.length)"
            v-edit="'ContentBlocks'"
            class="policies-info-page__content-blocks"
          >
            <component
              :is="block.component | kebab"
              v-for="block in contentBlocks"
              :key="block.contentId"
              v-bind="block"
              :tracking-scope="title"
              :size="block.component == 'AccordionBlock' && 56"
              :expand-from-parent="block.component == 'AccordionBlock' && expandAccordions"
            >
              <template #content>
                <wysiwyg :content="block.content" />
              </template>
            </component>
          </div>
          <div
            v-if="content2.length || contentBlocks2.length || isEditable"
          >
            <wysiwyg
              v-if="content2.length || isEditable"
              v-edit="'Content2'"
              class="wysiwyg--contentarea"
              :content="content2"
            />
          </div>
          <div
            v-if="contentBlocks2.length || (isEditable && contentBlocks2.length)"
            v-edit="'ContentBlocks2'"
            class="policies-info-page__content-blocks"
          >
            <component
              :is="block.component | kebab"
              v-for="block in contentBlocks2"
              :key="block.contentId"
              v-bind="block"
              :tracking-scope="title"
              :size="block.component == 'AccordionBlock' && 56"
              :expand-from-parent="block.component == 'AccordionBlock' && expandAccordions"
            >
              <template
                v-if="block.component == 'AccordionBlock'"
                #content
              >
                <wysiwyg :content="block.content" />
              </template>
            </component>
          </div>
        </div>
      </div>
    </div>


    <div
      v-if="contactBlocks.length"
      v-edit="'Contactblocks'"
      class="contact-blocks-wrapper policies-info-page--contact-blocks-wrapper"
    >
      <in-view
        :threshold="0"
        :threshold-type="'px'"
        class="slide-into-view-transition"
      >
        <div
          class="row-1-noGutter-center_md-3 margin-gutter"
        >
          <contact-block
            v-for="(item,index) in contactBlocks"
            :key="index"
            v-bind="item"
            class="col"
          />
        </div>
      </in-view>
    </div>

    <div
      v-if="accordionBlocks.length || isEditable"
      class="accordion-block-wrapper"
    >
      <sub-heading
        v-if="accordionsHeading || isEditable"
        :v-edit-heading="'AccordionsHeading'"
        :heading="accordionsHeading"
      />

      <in-view
        :threshold="0"
        :threshold-type="'px'"
        class="slide-into-view-transition"
      >
        <div
          v-edit="'AccordionBlocks'"
        >
          <accordion-group
            :items="accordionBlocks | stringify('content')"
            :limit="isEditable ? 0 : accordionShowMoreLimit"
            :tracking-scope="accordionsHeading"
          />
        </div>
      </in-view>
    </div>

    <navigation-group-block
      v-for="block in contentArea"
      :key="block.contentId"
      v-bind="block"
    />
  </div>
</template>
<script>
import Form from '@/vue/components/common/Form'
import PreambleBlock from '@/vue/blocks/PreambleBlock/preambleBlock'
import pageWithNavigation from '@/vue/mixins/pageWithNavigation'
import IcaToggleSwitch from "~/@ica/ica-molecules-vue/dist/ToggleSwitch"
import BylineShareComponent from '@/vue/components/bylineShareComponent/bylineShareComponent'
import IcaYoutubeVideo from '~/@ica/ica-molecules-vue/dist/YoutubeVideo'

import '#/Social/Twitter'
import '#/Social/Facebook'
import '#/Communication/Link'

export default {
  name: "PoliciesInfoPage",
  components: {
    Form,
    PreambleBlock,
    IcaToggleSwitch,
    BylineShareComponent,
    IcaYoutubeVideo
  },
  mixins: [pageWithNavigation],
  props: {
    prefix: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
     seoDescription: {
      type: String,
      default: ''
    },
    seoTitle: {
      type: String,
      default: ''
    },
    preamble: {
      type: String,
      default: ""
    },
    content: {
      type: Array,
      default: () => []
    },
    content2: {
      type: Array,
      default: () => []
    },
    contentBlocks: {
      type: Array,
      default: () => []
    },
    contentBlocks2: {
      type: Array,
      default: () => []
    },
    contactBlocks: {
      type: Array,
      default: () => []
    },
    breadcrumbs: {
      type: Array,
      default () {
        return []
      }
    },
    forms: {
      type: Array,
      default () {
        return []
      }
    },
    author: {
      type: String,
      default: ""
    },
    authorDate: {
      type: String,
      default: ""
    },
    displayImagesInNavigationBlocks: {
      type: Boolean,
      default: false
    },
    image: {
      type: Object,
      default: null
    },
    alt: {
      type: String,
      default: 'Film från youtube, saknar beskrivning'
    },
    videoUrl: {
      type: String,
      default: null
    },
    accordionsHeading: {
      type: String,
      default: ""
    },
    accordionBlocks: {
      type: Array,
      default () {
        return []
      }
    },
    factBlocks: {
      type: Array,
      default () {
        return []
      }
    },
    accordionShowMoreLimit: {
      type: Number,
      default: 0
    },
    contentAreaTitle: {
      type: String,
      default: ""
    },
    contentArea: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      show: true,
      expandAccordions: false
    }
  },
  computed: {
    aspectRatioMode () {
      return this.$root.currentSizeLte('sm')
    },
    hasAccordions () {
     return this.contentBlocks.filter(block => block.component == "AccordionBlock").length > 0 || !!this.contentBlocks2.filter(block => block.component == "AccordionBlock").length > 0
    }
  }
  }
</script>
<style lang="scss">

.policies-info-page-wrapper {
  padding: 0;
}

.policies-info-page {
  margin: 0 -1rem;
  padding: 2rem 0  2rem 0;
  border-radius: 0.25rem;

  @include media-breakpoint-up(md) {
    margin: 0;
    padding: 3rem 0  4.5rem 0;
  }

  @include media-breakpoint-up(lg) {
    padding: 3.5rem 0  5.5rem 0;
  }

  @include media-breakpoint-up(xl) {
    padding: 4rem 0  6.5rem 0;
  }

  &__content-blocks {
    margin: 0 1.5rem;

    @include media-breakpoint-up(md) {
      margin: 0 10.33333%;
    }

    @include media-breakpoint-up(lg) {
      margin: 0 12.378959%;
    }

    .wysiwyg ul {
      list-style: disc;
      list-style-position: outside;
      margin: 0 0 1rem 1.25rem;

      li {
        padding: 0;

        &::before {
          display: none;
        }
      }
    }

    .accordion-block {
      box-shadow: none;
      border: 1px solid $color-grey-special;
      border-radius: 4px;

      &__content-wrapper {
        border-top: 1px solid $color-grey-special;
      }
    }

    .title-text-block {
      margin: 2rem 0 0 0;

      @include media-breakpoint-up(lg) {
        margin: 2.5rem 0 0 0;
      }
    }
  }

  & .image-video-wrapper {
    margin-bottom: 2rem;

    @include media-breakpoint-up(xl) {
      margin-bottom: 4rem;
      padding: 0 13rem;
    }
  }

  background-color: $color-white;

  &__content {
    @include font(text,3, "normal");

    margin-bottom: 2.5rem;
  }

  .epi-background-container,
  .empty-image-placeholder {
    border-radius: 0.25rem;
    padding-bottom: 56.25%;
  }

  .empty-image-placeholder {
    height: auto;
  }

  &__form-wrapper {
    padding: 0 1.5rem;

    @include media-breakpoint-up(md) {
      padding: 0 6.4375rem;
    }
  }

  .offer {
    margin: 1rem 0.5rem;
    border: 0.0625rem solid $color-grey-special;

    @include media-breakpoint-up(md) {
      margin: 1.5rem 0;
    }

    &__content {
      text-align: left;
      min-height: 0;

      .offer__rules {
        margin-bottom: 0;
      }
    }

    &__content-wrapper {
      padding: 1rem;
      flex-direction: row;
    }

    &__image-wrapper {
      margin-bottom: 0;

      @include media-breakpoint-up(md) {
        margin-right: 2rem;
      }
    }

    .button--text-icon {
      margin: 0;
      width: auto;
    }
  }

  &--contact-blocks-wrapper {
    .contact-block-wrapper {
      @include contactBlock();
    }
  }
}

.toggle-accordions--wrapper {
  padding: 0 1rem;

  @include media-breakpoint-up(md) {
    padding: 0 10.33333%;
  }

  @include media-breakpoint-up(lg) {
    padding: 0 12.378959%;
  }

  hr {
    margin-top: 1rem;
    margin-bottom: 2rem;
    display: block;
    border: none;
    border-top: 1px solid $color-grey-special;
    width: 100%;
    height: 1px;

    @include media-breakpoint-up(md) {
      margin-bottom: 3rem;
    }

    @include media-breakpoint-up(lg) {
      margin-bottom: 2.5rem;
    }
  }
}

.policies-info-page-accordion {
  margin-top: 2rem;

  @include media-breakpoint-up(md) {
    margin-top: 3rem;
  }

  @include media-breakpoint-up(lg) {
    margin-top: 3.5rem;
  }

  @include media-breakpoint-up(xl) {
    margin-top: 4rem;
  }
}

.wysiwyg--policies-info-page {
  h2 {
    @include font(rubrik, 4, "normal");

    margin: 0 0 0.5rem;
  }
}

</style>

